import html from "./SurveyStep.html"
import "./SurveyStep.css"
import "./SurveyThemes.css"
import "./Steps/CaptureStep.js"
import "./Steps/CompletionStep.js"
import "./Steps/ConsentReviewStep.js"
import "./Steps/CountdownStep.js"
import "./Steps/FormStep.js"
import "./Steps/InstructionStep.js"
import "./Steps/QuestionStep.js"
import "./Steps/UnsupportedStep.js"
import "./Steps/VideoInstructionStep.js"
import "./Steps/VisualConsentStep.js"
import "./Steps/WaitStep.js"
import "./Steps/WebViewStep.js"
import "./Controls/NextButton.js"
import "./FinishSteps.js"
import "./TemplateValidator.js"

var module = angular.module("ResearchKitApplicationModule");

module.directive("surveyStep",
	["$timeout", function ($timeout) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "=",
				"render": "=?"
			},
			link: function (scope, element, attrs) {
				const surveyStepElement = element.children(":first");
				scope.$watch("stepManager.step.identifier", (stepIdentifier) => {
					if (stepIdentifier) {
						surveyStepElement.removeClass("visible");
						$timeout(() => {
							surveyStepElement.addClass("visible");
						});
					}
				});
			}
		};
	}]
);

module.controller("surveyStepController", ["$scope", "templateValidator",
	function ($scope, templateValidator) {

		if (_.isUndefined($scope.render)) {
			$scope.render = true;
		}

		$scope.isLastInstructionStep = function () {
			var lastInstructionStepIndex = -1;
			for (var i = 0; i < $scope.template.steps.length; i++) {
				if ($scope.template.steps[i].type === 'InstructionStep') {
					lastInstructionStepIndex = i;
				} else {
					break;
				}
			}

			if ($scope.stepIndex === lastInstructionStepIndex) {
				return true;
			}
			return false;
		};

		$scope.getStyles = function () {
			if (!$scope.stepManager) { return {}; }
			var styles = $scope.stepManager.getBackgroundStyles();
			if ($scope.stepManager && $scope.stepManager.surveyManager && $scope.stepManager.surveyManager.getMode() !== "Design") {
				styles["width"] = "auto";
			}
			return styles;
		};

		$scope.getClasses = function () {
			var classes = {};
			if (!$scope.stepManager) { return; }
			if ($scope.stepManager.surveyManager.template.theme) {
				classes[$scope.stepManager.surveyManager.template.theme] = true;
			}
			if ($scope.stepManager.getFormStyle() == 'cardBased') {
				classes["card-based"] = true;
			}
			if ($scope.stepManager.getFormStyle() == 'v2') {
				classes["survey-step-v2"] = true;
			}
			return classes;
		}

		$scope.$on("SurveyTemplateModified", function (evt, data) {
			// template is available on the stepManager.surveyManager but we want to avoid adding another deep watch
			$scope.templateValidationErrors = templateValidator.validate($scope.stepManager.step, $scope.stepManager.surveyManager.template);
		});

		let surveyHeaderProps = null;
		$scope.surveyHeaderProps = function () {
			let newProps = {
				onBack: function () {
					$scope.stepManager.back();
					$scope.$apply();
				},
				onContinue: function () {
					$scope.stepManager.continue();
					$scope.$apply();
				},
				onClose: function () {
					$scope.stepManager.closeSurvey();
					$scope.$apply();
				},
				onSaveAndClose: function () {
					$scope.stepManager.saveAndCloseSurvey();
					$scope.$apply();
				},
				canGoBack: $scope.stepManager.canGoBack(),
				showSaveAndClose: $scope.stepManager.showSaveAndClose(),
				showCancelButton: $scope.stepManager.showCancelButton(),
				stepDefinition: $scope.stepManager.step,
				surveyDefinition: $scope.stepManager.surveyManager.template
			};

			if (!angular.equals(surveyHeaderProps, newProps)) {
				surveyHeaderProps = newProps;
			}
			return surveyHeaderProps;
		}
	}
]);